import * as React from 'react'
import { useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'

interface MissingCategoriesModalProps {
  onClose: () => void
}

export const MissingCategoriesModal = ({ onClose }: MissingCategoriesModalProps) => {
  const { canManagePayrollSettings } = useOutletContext<RouteContextParams>()
  const { navigation } = useNavigation()

  const descriptionLabel = canManagePayrollSettings
    ? i18n.t('expenses_v2.payroll.missing_categories_modal.description')
    : i18n.t('expenses_v2.payroll.missing_categories_modal.non_admin_description')

  const closeLabel = canManagePayrollSettings
    ? i18n.t('expenses_v2.list.actions.modal.cancel')
    : i18n.t('expenses_v2.list.actions.modal.got_it')

  return (
    <Modal
      title={i18n.t('expenses_v2.payroll.missing_categories_modal.title')}
      description={descriptionLabel}
      footer={
        canManagePayrollSettings ? (
          <>
            <Button type="secondary" onClick={onClose}>
              {closeLabel}
            </Button>
            <Button.Router to={navigation.settings.payroll_bundle.expensesReimbursement.fullPath()}>
              {i18n.t('expenses_v2.list.actions.modal.manage_categories_and_titles')}
            </Button.Router>
          </>
        ) : (
          <Button onClick={onClose}>{closeLabel}</Button>
        )
      }
      onClose={onClose}
    />
  )
}
